<template>
  <Layout>
    <router-view></router-view>
  </Layout>
</template>

<script>
export default {
  name: "Base"
}
</script>

<style scoped>

</style>